/* eslint-disable no-console */
import moment from 'moment';
import { useEffect, useState, useRef } from 'react';

moment.locale('ru');

const STORAGE_WORKSPACE_KEY = 'workspaceConfigValues';

// Функция подмена домена до точки
const apiReplace = (hostName) => {
  if (hostName === 'www.console.stpartner.ru') {
    return 'www.api.stpartner.ru';
  }

  if (hostName === 'avtoconsole.ru') {
    return 'api.avtoconsole.ru';
  }

  const a = hostName.split('.');

  if (a[1] === 'stpartner') {
    a[0] = 'api0';
  } else {
    a[0] = 'api';
  }

  return a.join('.');
};

const $apiUrl = process.env.API_URL === 'location_host'
  ? window.location.origin.replace(window.location.hostname, apiReplace(window.location.hostname))
  : process.env.API_URL;

console.log('> NAME::', process.env.APP_NAME);
console.log('> VERSION::', process.env.APP_VERSION);
console.log('> SERVER::', $apiUrl);
console.log('> NODE_ENV::', process.env.NODE_ENV);
console.log('> DEBUG::', process.env.DEBUG);

const getSavedValues = () => {
  try {
    const savedValues = localStorage.getItem(STORAGE_WORKSPACE_KEY);
    return savedValues ? JSON.parse(savedValues) : {};
  } catch {
    return {};
  }
};

// Вынесена отдельно для использования в хуке
const getAppConfig = () => ({
  name: process.env.APP_NAME,
  version: process.env.APP_VERSION,
  serverAddress: $apiUrl,
  connectivityError: 'Возникла ошибка сети. Проверьте соединение с интернет.',
  errorHdr: 'Возникла ошибка',
  successHdr: 'Успех',
  successSaveMsg: 'Изменения сохранены',
  page403Text: 'У вас недостаточно прав для доступа к этой странице.',
  error_to_email_text: 'Попробуйте ещё раз. В случае повторения ошибки отправьте текст ошибки на Email: support@avtoapp.ru',
  error_to_email: 'support@avtoapp.ru',
  STORAGE_WORKSPACE_KEY: STORAGE_WORKSPACE_KEY,
  officeFromLocalStorage: getSavedValues()?.selectedOffice ?? {},
  executorsFromLocalStorage: getSavedValues()?.usersBySelectedOffice ?? [], 
  executorsCreatedAt: getSavedValues()?.createdAt ?? undefined,
});

// Кастомный хук для реактивного доступа к конфигу
export function useAppConfig() {
  const [config, setConfig] = useState(getAppConfig);
  const prevConfigRef = useRef(config);

  useEffect(() => {
    const checkForChanges = () => {
      const newConfig = getAppConfig();
      
      // Глубокое сравнение объектов - обновляем только если данные действительно изменились
      const stringify = (obj) => JSON.stringify({
        officeId: obj.officeFromLocalStorage?.id,
        partnerId: obj.officeFromLocalStorage?.partnerId,
        executorsCount: obj.executorsFromLocalStorage?.length,
      });
      
      if (stringify(newConfig) !== stringify(prevConfigRef.current)) {
        prevConfigRef.current = newConfig;
        setConfig(newConfig);
      }
    };

    // Слушаем изменения localStorage
    const handleStorageChange = (event) => {
      if (event.key === STORAGE_WORKSPACE_KEY) {
        checkForChanges();
      }
    };

    window.addEventListener('storage', handleStorageChange);
    
    // Периодически проверяем изменения, но реже - каждые 2 секунды
    const interval = setInterval(checkForChanges, 2000);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(interval);
    };
  }, []);

  return config;
}

// Для обратной совместимости оставляем экспорт по умолчанию
const appConfig = getAppConfig();
export default appConfig;